import { Color, Style } from "./alert-variants.ts";
import { Root, createRoot } from "react-dom/client";
import { Alert } from "./alert.tsx";

interface PopupAlertProps {
  message: string;
  color: Color;
  style: Style;
  title?: string;
}

let alertReactRoot: Root | null = null;
let rootElement: HTMLElement | null = null;

const createRootIfNotExist = () => {
  if (alertReactRoot) {
    return alertReactRoot;
  }
  rootElement = document.createElement("div");
  rootElement.id = "alert-root";
  rootElement.style.position = "absolute";
  rootElement.style.left = "50%";
  rootElement.style.top = "10%";
  rootElement.style.zIndex = "1000";
  rootElement.className = "twp";
  rootElement.style.transform = "translate(-50%, 0px)";
  document.body.appendChild(rootElement);
  alertReactRoot = createRoot(rootElement);
  return alertReactRoot;
};
export const showPopupAlertFromLocalStorage = () => {
  const alertJson: string | null = window.sessionStorage.getItem("alert");

  // only show alert if there's something to show
  if (!alertJson) {
    return;
  }
  window.sessionStorage.removeItem("alert");
  const alert = JSON.parse(alertJson) as PopupAlertProps;
  // add a root at the end of the body
  const reactRoot = createRootIfNotExist();
  reactRoot.render(
    <Alert
      color={alert.color}
      style={alert.style}
      message={alert.message}
      title={alert.title}
      dismissible
      onDismiss={() => {
        reactRoot.unmount();
        rootElement?.remove();
      }}
      renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-shield-check" />}
    />,
  );
  window.setTimeout(() => {
    reactRoot.unmount();
    rootElement?.remove();
  }, 5000);
};

export const setPopupAlertInLocalStorage = (alert: PopupAlertProps) => {
  window.sessionStorage.setItem("alert", JSON.stringify(alert));
};

export const showSuccessMessage = (message: string) => {
  const reactRoot = createRootIfNotExist();
  reactRoot.render(
    <Alert
      color={"green"}
      style={"solid"}
      message={message}
      dismissible
      onDismiss={() => {
        reactRoot.unmount();
        rootElement?.remove();
      }}
      renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-shield-check" />}
    />,
  );
  window.setTimeout(() => {
    reactRoot.unmount();
    rootElement?.remove();
  }, 5000);
};
